import { Component } from '@angular/core';
import { SupplyChainDirectAccountService } from './supply-chain-direct-account.service';

@Component({
    selector: 'supply-chain-direct-account',
    template: `
        <div
            class="supply-chain-direct-account-page supply-chain-direct-page min-full-height-content"
        >
            <router-outlet></router-outlet>
        </div>
    `
})
export class SupplyChainDirectAccountComponent {
    constructor(public supplyChainDirectAccountService: SupplyChainDirectAccountService) {}

    public ngOnInit(): void {
        this.supplyChainDirectAccountService.initialize();
    }

    public ngOnDestroy(): void {
        // If you don't reset the array, the multi select will populate with old results if you logout and login with a new account.
        this.supplyChainDirectAccountService.reset();
    }
}
